module.exports = __webpack_public_path__ + "img/DC_BenKweller_0002.21a97890.jpg";